import{gql as n}from"@apollo/client";const e=n`
  fragment geladaOrganisationFragment on OrganisationGraphType {
    description
    id
    key
    logo @include(if: $shouldIncludeOrganisationLogo) {
      assetId
      contentType
      presignedUrl
      s3Key
    }
    name
    tag
    url
  }
`;export{e as GELADA_ORGANISATION_FRAGMENT};
//# sourceMappingURL=geladaOrganisation.fragment.js.map
